import { useEffect, useState } from "react";
import styles from "../styles/TeacherResources.module.scss";
import axios from "axios";
import { GET_PDF_URL } from "../../../../utils/api";
import { apiRequest } from "../../../../api/apiRequest";

export default function ResourcePreviewModal({
  pdfUrl,
  clickedFile,
  resource,
  open,
  onClose,
}) {
  const [viewPdf, setViewPdf] = useState("");

  const fileUrl = pdfUrl || resource?.thumb; // fallback to thumb if no fileUrl

  useEffect(() => {
    if (pdfUrl) {
      getPdf();
    }
  }, [pdfUrl]);

  // const getPdf = async () => {
  //   const token = localStorage.getItem("access_token") || null;

  //   try {
  //     const resp = await axios.get(
  //       `${GET_PDF_URL}/${resource?.material_id}.pdf`,
  //       {
  //         headers: { Authorization: `Bearer ${token}` },
  //         withCredentials: true,
  //         responseType: "blob",
  //       }
  //     );

  //     if (resp.status === 200) {
  //       const blobUrl = URL.createObjectURL(resp.data);
  //       setViewPdf(blobUrl);
  //     }
  //   } catch (error) {
  //     console.error("Failed to load PDF:", error);
  //   }
  // };

  const getPdf = async () => {
  const result = await apiRequest(
    "get",
    `${GET_PDF_URL}/${resource?.material_id}`,
    null,
    { responseType: "blob" }
  );

  if (result.success) {
    const blobUrl = URL.createObjectURL(result.data);
    setViewPdf(blobUrl);
  } else {
    console.error("Failed to load PDF:", result.message);
  }
};

  const handleOpenNewTab = () => {
    if (!viewPdf) return;
    try {
      const win = window.open(viewPdf, "_blank");
      if (!win) alert("Please allow popups to view this file.");
    } catch (err) {
      alert("Unable to open file in new tab.");
    }
  };
  if (!open || !resource) return null;

  return (
   <div className={styles.addModalOverlay} role="dialog">
  <div className={styles.addModal} onClick={(e) => e.stopPropagation()}>
    <button className={styles.addModalClose} onClick={onClose}>
      ×
    </button>

        <div style={{ display: "flex", gap: 12 }}>
          <div style={{ flex: 1, minHeight: 360 }}>
            {viewPdf ? (
              <object
                data={viewPdf}
                type="application/pdf"
                width="100%"
                height="400"
              >
                <p>
                  PDF preview not supported.{" "}
                  {/* <button onClick={handleOpenNewTab}>Open in new tab</button> */}
                </p>
              </object>
            ) : (
              <img
                src={pdfUrl}
                alt={resource.title}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  minHeight: 360,
                }}
              />
            )}
          </div>

          <div
            style={{
              width: 300,
              display: "flex",
              flexDirection: "column",
              gap: 12,
            }}
          >
            <h3 style={{
              margin: 0,
              wordBreak: "break-word",
              overflowWrap: "break-word",
              whiteSpace: "normal",
              fontSize: "18px",
              lineHeight: "1.4",
            }}>
              {resource?.file_name}
            </h3>
            <div style={{ color: "#6b7280" }}>{resource.author}</div>
            <div style={{ fontSize: 13, color: "#6b7280" }}>
             
                <>Chapter: {resource?.chapter ? resource?.chapter : "N/A" }<br /></>
            
                {/* <>Class: {resource?.class ? resource?.class : "N/A"}<br /></>
            
               <>Board: {resource?.board ? resource?.board : "N/A"}<br /></> 
             
                <>Medium: {resource?.medium ? resource?.medium : "N/A"}<br /> </> */}
        
            </div>

            <div style={{ marginTop: "auto", display: "flex", gap: 8 }}>
              <a
                href={viewPdf}
                download={resource?.file_name}
                className={styles.primaryBtn}
                style={{ textDecoration: "none", display: "inline-block" }}
              >
                Download
              </a>
              <button
                onClick={handleOpenNewTab}
                className={styles.ghostBtn}
                style={{ alignSelf: "center" }}
              >
                Open
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
